import React from "react";
import { Link } from "react-router-dom";
import "../../styles/PrivacyPolicyPage.css";

const LAST_UPDATED = "26 July 2026";

const PrivacyPolicyPage = () => {
  return (
    <section className="privacy-policy-page">
      <div className="privacy-policy-content">
        <h1>Privacy Policy</h1>
        <p className="privacy-updated">Last updated: {LAST_UPDATED}</p>

        <p>
          This privacy policy explains how the WIBI-TEC website (wibitec.com)
          handles information when you browse products, search the catalogue, or
          contact us. It describes only practices that apply to this website
          today.
        </p>

        <h2>Who we are</h2>
        <p>
          WIBI-TEC provides industrial equipment information and contact
          channels. For privacy questions, contact us using the details already
          published on this site:
        </p>
        <ul>
          <li>
            Email: <a href="mailto:sales@wibitec.com">sales@wibitec.com</a>
          </li>
          <li>
            Phone / WhatsApp:{" "}
            <a href="https://wa.me/+971504289825">+971 50 428 9825</a>
          </li>
        </ul>

        <h2>Information we process</h2>
        <h3>Product browsing and search</h3>
        <p>
          You can browse brands, categories, and product pages, and use the
          header search. Search suggestions and product pages are loaded from
          static catalogue files hosted with the website. We do not require an
          account to browse the catalogue.
        </p>

        <h3>Contact and enquiry actions</h3>
        <p>
          If you email us, call us, or message us on WhatsApp, the information
          you choose to send is handled through those communication channels so
          we can respond to your enquiry. Do not include sensitive personal
          information that is not needed for your request.
        </p>

        <h3>Contact forms</h3>
        <p>
          Where a contact or enquiry form is available, we use the information
          you submit (such as contact details and message content) only to
          respond to your request. Form submissions are processed through the
          form service configured on this website.
        </p>

        <h3>Website analytics</h3>
        <p>
          This website uses Google Analytics 4 (measurement ID{" "}
          <code>G-X4SD7EQ0P7</code>) to understand aggregate website usage, such
          as pages viewed and whether catalogue searches or product pages were
          opened. Analytics runs automatically when the website loads.
        </p>
        <p>
          We configure Google Analytics with IP anonymization and with
          advertising features (Google signals and ad personalization) disabled.
          This website does not use Google Ads or Google Tag Manager. We do not
          send personal details such as names, email addresses, telephone
          numbers, message content, uploaded file names, or raw search queries
          to Google Analytics.
        </p>

        <h3>Hosting, CDN, and security logs</h3>
        <p>
          This website is hosted on Cloudflare Pages. Cloudflare may process
          standard technical data (such as IP address, browser type, and request
          metadata) to deliver content securely through its CDN and to help
          protect the service. Those logs are used for security, reliability,
          and delivery of the website.
        </p>

        <h2>What we do not do</h2>
        <ul>
          <li>We do not sell personal information.</li>
          <li>
            We do not intentionally collect sensitive personal data through this
            website.
          </li>
          <li>
            We do not operate a customer account or login-tracking system for
            catalogue browsing on this site.
          </li>
          <li>
            We do not send the contents of your search box to analytics events.
          </li>
        </ul>

        <h2>Cookies and analytics</h2>
        <p>
          Google Analytics sets cookies to measure aggregate website usage.
          These cookies are used for analytics measurement only and are not used
          for advertising. You can control or block cookies through your browser
          settings, and you can use browser privacy tools or extensions to opt
          out of analytics.
        </p>

        <h2>How long information is kept</h2>
        <p>
          Contact messages are retained only as long as needed to handle your
          enquiry and related business records. Analytics data retained by
          Google Analytics is subject to Google&apos;s retention settings for
          this property. Cloudflare may retain security and delivery logs
          according to its service configuration.
        </p>

        <h2>Your choices</h2>
        <p>
          You can manage analytics cookies through your browser settings or
          privacy tools. You may also contact us at{" "}
          <a href="mailto:sales@wibitec.com">sales@wibitec.com</a> with privacy
          questions.
        </p>

        <h2>Changes to this policy</h2>
        <p>
          We may update this page when our website practices change. The “Last
          updated” date at the top will be revised when that happens.
        </p>

        <p className="privacy-back-link">
          <Link to="/">Back to home</Link>
          {" · "}
          <Link to="/contact">Contact</Link>
        </p>
      </div>
    </section>
  );
};

export default PrivacyPolicyPage;
